import {ref} from 'vue';
import {useRoute} from '#imports';

export function usePageSource() {
    const pageSource = ref<string>();
    const route = useRoute();

    if (route.fullPath.startsWith('/resources')) {
        pageSource.value = 'resource_center';
    } else if (route.fullPath.startsWith('/c/') || route.fullPath.startsWith('/s/tags/') || route.fullPath.startsWith('/a/')) {
        pageSource.value = 'cms_marketing_page';
    } else if (route.name === 'profileIdOrAlias') {
        pageSource.value = 'profile_page';
    } else if (route.name === 's') {
        pageSource.value = 'search';
    } else if (route.fullPath.startsWith('/')) {
        pageSource.value = 'home';
    }

    return {
        pageSource,
    };
}
